import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import * as fromAuth from '@store/reducers';
import * as fromCommonActions from '@store/actions/common.actions';
import { StaffAppRoutesEnum } from '@staff-app/staff-app-routes-enum';

@Injectable()
export class AuthGuard implements CanActivate {
  constructor(private store: Store<fromAuth.State>,    private router: Router    ) { }

  canActivate(): Observable<boolean> {
    return this.store.pipe(
      select(fromAuth.getIsLoggedIn),
      map(authed => {
        const authData = sessionStorage.getItem('pulse.authorizationData');

        if (!authed && (authData && JSON.parse(authData).token)) {
          this.store.dispatch(
            new fromCommonActions.RedirectToUrl(StaffAppRoutesEnum.AutoLogin)
          );
          return false;
        }
        else if (!authed) {
          this.router.navigate([StaffAppRoutesEnum.Login]);
          return false;
        }
        else {
          return true;
        }
      }),
      take(1)
    );
  }
}
